import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils'; const cls = classNames('cookie-banner-message');
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { useCookieBannerFeaturesList, useLink } from '@shapeable/ui';


// -------- Types -------->

export type CookieBannerMessageProps = Classable & HasChildren & {
  privacyPath: string;
}

export const CookieBannerMessageDefaultProps: Omit<CookieBannerMessageProps, 'privacyPath'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->


const ContainerStyles = breakpoints({
  base: css`
  `,
});

const TitleStyles = breakpoints({
  base: css`
    font-weight: 500;
    color: ${theme.COLOR('strong')};
    margin-bottom: 0;
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Title: styled.h1`${TitleStyles}`,
};

export const CookieBannerMessage: Shapeable.FC<CookieBannerMessageProps> = (props) => {
  const { className, privacyPath } = props;
  const { Link } = useLink();
  const featuresList = useCookieBannerFeaturesList();

  return (
    <My.Container className={cls.name(className)}>
    <My.Title>Mmmm Cookies.</My.Title>
      <p>
      Not those cookies - digital cookies - small pieces of text that we send to your browser and are then stored on your computer. 

      </p>
      <p>
      Cookies are essential website functionality and analytics. On the Future Council website we currently use: 
      <ul>
        <li><b>Contact Form Cookie:</b> allows the form feature (Netlify)</li>
      </ul>

      </p>
      <p>
        By clicking "ACCEPT ALL," you consent to the use of all of the cookies.
      </p>
      <p>
        Select "ACCEPT FUNCTIONAL ONLY" to be able to use the Contact Form.
      {/* {featuresList} */}
      <p>
        If you click "REJECT ALL,” then the Contact Form won’t work.
      </p>
      {
        privacyPath &&
        <p>
          For more information on the types of cookies we use, please read our <Link href={privacyPath}>Privacy Policy</Link>.
        </p>
      } 
      </p>
   
    </My.Container>
  )
};

CookieBannerMessage.cls = cls;
CookieBannerMessage.defaultProps = CookieBannerMessageDefaultProps;